import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './i18n/en.json';
import ru from './i18n/ru.json';
import es from './i18n/es.json';

export const supportedLanguages: string[] = ['en', 'ru', 'es'];

export const isSupportedLanguage = (language?: string): boolean => supportedLanguages.includes(language);

const resources = {
    en: {
        translations: en,
    },
    ru: {
        translations: ru,
    },
    es: {
        translations: es,
    },
};

const storedLanguage: string = localStorage.getItem('locale');
const defaultLanguage: string = isSupportedLanguage(storedLanguage) ? storedLanguage : 'en';

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: defaultLanguage,
        fallbackLng: 'en',
        debug: false,
        /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
        ns: ['translations'],
        defaultNS: 'translations',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },
        react: {
            //wait: false,
            useSuspense: false,
        },
    }, () => {});

export default i18n;
